import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('AuthModule', { _$openCashDesk: 'openCashDesk' }),
    },
    methods: {
        ...mapActions('AuthModule', {
            _$fetchCashDeskStatus: 'fetchCasDeskStatus',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        _$openCashdeskWarning() {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'info',
                message: {
                    title: 'Apertura de Caja',
                    body: 'Debe realizar la apertura de caja',
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        _$checkCashDeskStatus() {
            return new Promise((resolve, reject) => {
                if (this._$openCashDesk === true) {
                    return resolve(true)
                }
                if (
                    [null, undefined, false].includes(this._$openCashDesk) ||
                    ![true, false].includes(this._$openCashDesk)
                ) {
                    this._$fetchCashDeskStatus()
                        .then(r => {
                            if (r === 'closed') {
                                this._$openCashdeskWarning()
                                return resolve(false)
                            }
                            return resolve(true)
                        })
                        .catch(reject)
                }
            })
        },
    },
    beforeRouteLeave(to, from, next) {
        if (
            [
                'rendicion',
                'reports',
                'salir',
                'transbank',
                'reimprimir',
                'cash-movement',
            ].includes(to.name)
        )
            return next()
        this._$checkCashDeskStatus()
            .then(r => {
                if (r !== true) return next(false)
                return next()
            })
            .catch(() => next(false))
    },
}
